<template>
  <div
    class="form__input"
    :class="{'form__input--error': !!error }"
  >
    <label
      v-if="label"
      :for="id"
      class="form__label"
    >
      {{ label }}
    </label>

    <textarea
      :id="id"
      :type="type"
      :value="value"
      :disabled="disabled"
      :class="{ 'input': true, 'input__error': !!error, 'has-input': value !== '' }"
      :name="name"
      :maxlength="maxlength"
      @input="updateValue"
      @change="changeValue"
      @blur="$emit('blur')"
    />

    <p
      v-show="error"
      class="form__error"
    >
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    name() {
      return this.label;
    },
    value() {
      return this.value;
    },
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: 'Form Label',
    },
    name: {
      type: String,
      default: 'form-name',
    },
    id: {
      type: String,
      default: 'form-id',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
      required: false,
    },
    type: {
      type: String,
      default: 'text',
      validator: val => ['url', 'text', 'password', 'email', 'search'].indexOf(val) !== -1,
    },
    maxlength: {
      type: Number | String,
      default: '',
      required: false,
    }
  },
  methods: {
    updateValue(e) {
      this.$emit('input', e.target.value);
    },
    changeValue(e) {
      this.$emit('change', 'input', e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
